import { createContext, useContextSelector } from '@fluentui/react-context-selector';
export const listContextDefaultValue = {
    navigable: false,
    selection: undefined,
    as: undefined
};
const listContext = createContext(undefined);
export const ListContextProvider = listContext.Provider;
export const useListContext_unstable = (selector)=>useContextSelector(listContext, (ctx = listContextDefaultValue)=>selector(ctx));
